/* eslint-disable import/prefer-default-export */
import { useState } from 'react';

export const useBoolean = (initialState = false) => {
  const [state, setState] = useState(initialState);

  const setTrue = () => setState(true);
  const setFalse = () => setState(false);
  const toggleState = () => setState(!state);

  return {
    state,
    setState,
    setTrue,
    setFalse,
    toggleState,
  };
};
